<div class="input-group">
  <div class="input-group-prepend">
    <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button"><i class="bi bi-calendar"></i></button>
  </div>
  <input class="form-control" placeholder="dd/mm/yyyy"
         name="dp" [(ngModel)]="model" ngbDatepicker #d="ngbDatepicker" (ngModelChange)="eventChange()">
 
</div>